import owd from 'owd/owd';
import handlebars from 'handlebars/dist/handlebars';

export default class Handlebars extends owd.Module {
    constructor(app) {
        super(app);

        this.templates = {};
        this.registerHelpers();
        this.compile();
    }

    compile() {
        $('[type="text/template"]').each((index, item) => {
            this.templates[$(item).attr('data-template')] = handlebars.compile($(item).html());
        });
    }

    render(tpl, data) {
        tpl = tpl + '.handlebars';

        if (this.templates[tpl] !== undefined) {
            return this.templates[tpl](data);
        } else {
            console.error('Template not found', tpl);
            return '';
        }
    }

    registerHelpers() {
        handlebars.registerHelper('debug', function(val) {
          console.log(val);
        });
        
        handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {

            var operators, result;
        
            if (arguments.length < 3) {
                throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
            }
        
            if (options === undefined) {
                options = rvalue;
                rvalue = operator;
                operator = "===";
            }
        
            operators = {
                '==': function (l, r) { return l == r; },
                '===': function (l, r) { return l === r; },
                '!=': function (l, r) { return l != r; },
                '!==': function (l, r) { return l !== r; },
                '<': function (l, r) { return l < r; },
                '>': function (l, r) { return l > r; },
                '<=': function (l, r) { return l <= r; },
                '>=': function (l, r) { return l >= r; },
                'typeof': function (l, r) { return typeof l == r; }
            };
        
            if (!operators[operator]) {
                throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
            }
        
            result = operators[operator](lvalue, rvalue);
        
            if (result) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        });
        
        handlebars.registerHelper('pll', function(val) {
            if (pll[val] !== undefined) {
                return pll[val];
            }
            
            return val;
        });
    }
}